import { Box, Breadcrumbs, Button, Card, CardContent, Typography } from '@material-ui/core'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { NonAuthRoutes } from '../../../model'

import { EnumCommodity } from '../../../api'
import { FlexibilitiesModel } from '../../../api/Argentia/endpoints/flexibilities/model/flexibilities'
import Page from '../../../components/page/page'
import PageCenterColumn from '../../../components/page/pageCenterColumn'
import PageHeader from '../../../components/page/pageHeader'
import { BreadcrumbLink } from '../../../components/shared/breadcrumbLink/breadcrumbLink'
import { FlexibilitiesTable } from '../../../components/shared/flexibilitiesTable/flexibilitiesTable'
import useFlexibilities from '../../../components/shared/flexibilitiesTable/flexibilitiesTable.hooks'
import { storeActiveContract, storeActiveFlexibility } from '../../../redux'
import { FlexibilityTableModel } from '../../flexibility/flexibility.Model'
import { fetchSettlementGroupCommodity } from '../settlementGroups.service'

type SettlementGroupFlexibilitiesPageProps = {
  location: { state: { settlementGroupId: number; settlementGroupCode: string } }
}

export const SettlementGroupFlexibilitiesPage: React.FC<
  SettlementGroupFlexibilitiesPageProps
> = props => {
  const [t] = useTranslation(['globalerisLibrary', 'settlementGroups', 'enums'])
  const history = useHistory()

  const groupId = props.location.state.settlementGroupId
  const groupCode = props.location.state.settlementGroupCode

  const [commodity, setCommodity] = React.useState<EnumCommodity | null>(null)

  const { flexibilities, isFetchingFlexibilities, refreshFlexibilities } = useFlexibilities({
    commodity: commodity,
    settlementGroupCode: groupCode
  })

  const handleClickViewPriceComponents = (flexibility: FlexibilityTableModel) => {
    const flex = flexibilities?.find(item => item.id === flexibility.id)
    flex && handleViewAdditionals(flex)
  }

  const handleViewAdditionals = (flexibility: FlexibilitiesModel) => {
    storeActiveFlexibility(flexibility)
    history.push(NonAuthRoutes.PriceComponents)
  }

  const handleClickBackButton = () => {
    history.goBack()
  }

  const fetchCommodity = async (groupId: number) => {
    await fetchSettlementGroupCommodity(groupId).then(response => {
      if (response.success && response.data) {
        setCommodity(response.data)
      }
    })
  }

  const handleClickAddFlexibility = () => {
    history.push(NonAuthRoutes.flexibilityAdd, {
      settlementGroupId: groupId,
      settlementGroupDescription: groupCode,
      commodity
    })
  }

  useEffect(() => {
    // Clean Active Contract for proper navigation with flexibilities edit page (back button)
    storeActiveContract(null)

    fetchCommodity(groupId)
  }, [groupId])

  if (!groupCode) {
    history.goBack()
  }

  return (
    <Page fullWidth={true}>
      <PageHeader title={t('settlementGroups:titleFlexibilities', { groupCode })}>
        <Button variant="text" color="primary" onClick={handleClickBackButton}>
          {t('settlementGroups:actions.back')}
        </Button>
      </PageHeader>
      <PageCenterColumn>
        <Box mb={1}>
          <Breadcrumbs separator=">" aria-label="breadcrumb">
            <BreadcrumbLink toPathName="/settlementGroups">
              {`${t('settlementGroups:breadcrumbs.settlementGroups')}`}
            </BreadcrumbLink>
            <Typography key="3" color="primary" variant="subtitle2">
              {t('settlementGroups:breadcrumbs.group', { groupCode })}
            </Typography>
            <Typography key="3" color="primary" variant="subtitle1">
              {t('settlementGroups:breadcrumbs.flexibilities')}
            </Typography>
          </Breadcrumbs>
        </Box>
        <Card raised>
          <CardContent>
            <FlexibilitiesTable
              flexibilities={flexibilities}
              isFetchingFlexibilities={isFetchingFlexibilities}
              refreshFlexibilities={refreshFlexibilities}
              onClickViewPriceComponents={handleClickViewPriceComponents}
              onClickAddFlexibility={handleClickAddFlexibility}
            />
          </CardContent>
        </Card>
      </PageCenterColumn>
    </Page>
  )
}
